import "vuetify/styles";
import {createVuetify} from "vuetify";

const them = {
    dark: false,
    colors: {
        background: "#e9f1fe",
        surface: "#FFFFFF",
        primary: "#2196F3"
    }
}

export default createVuetify({
    options: {
        customProperties: true,
    },
    theme: {
        defaultTheme: 'them',
        themes: {them}
    },
})